export default {"src":"/_next/static/media/overview.1c0f6788.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};